<template>
    <div class="module">
        <div class="module-header d-flex">
            <h3 class="module-title">{{ $t('words.broadcast_list') }}</h3>
            <div class="module-action-group ml-auto">
                <div class="btn-group btn-group__date">
                    <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d')">{{ $t('words.period_today') }}</button>
                    <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d')">{{ $t('words.period_3d') }}</button>
                    <button :class="{'btn': true, 'active': (period==='7d')}" @click="changePeriod('7d')">{{ $t('words.period_7d') }}</button>
                    <button :class="{'btn': true, 'active': (period==='30d')}" @click="changePeriod('30d')">{{ $t('words.period_30d') }}</button>
                </div>
                <div class="input-group input-group-date input-daterange" id="date-range">
                    <div class="input-group">
                        <vue-date-picker
                            v-model="rangeDay"
                            value-type="format"
                            format="YYYY-MM-DD"
                            range
                            placeholder="Select date range"
                            :disabled-date="notRangedDate"
                        >
                        </vue-date-picker>
                    </div>
                    <div class="input-group-append">
                        <button type="button" :class="{'btn': true, 'btn-icon': true, 'active': (period==='custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="module-body">
            <div class="module-action-group" style="margin-bottom: 24px">
<!-- 통계 유지를 위해서 방송 삭제하는 버튼 제거 -->
<!--                <div class="btn-group mr-auto" v-if="caller==='channel'">-->
<!--                    <button class="btn btn-danger" @click="doDestroyBroadcasts" v-if="haveManagerRight && (broadcasts.data.length > 0)"><i class="icon icon-trash"></i>-->
<!--                        {{ $t('words.remove_broadcasts') }}-->
<!--                    </button>-->
<!--                </div>-->
                <nav aria-label="Page navigation" class="ml-auto">
                    <ul class="pagination">
                        <li class="page-info">
                            {{ $t('paragraphs.page_navigation', { total: broadcasts.meta.total, from: ((broadcasts.meta.current_page - 1) * broadcasts.meta.per_page + 1), to: (broadcasts.meta.current_page === broadcasts.meta.last_page ? broadcasts.meta.total : broadcasts.meta.per_page * broadcasts.meta.current_page )}) }}
                        </li>
                        <li :class="{'page-item': true, disabled: !broadcasts.links.prev }">
                            <button class="page-link" aria-label="Previous" @click="loadBroadcasts(broadcasts.links.prev)" v-if="broadcasts.links.prev">
                                <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.previous') }}</span>
                            </button>
                            <button class="page-link" aria-label="Previous" v-else>
                                <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.previous') }}</span>
                            </button>
                        </li>
                        <li :class="{'page-item': true, disabled: !broadcasts.links.next }">
                            <button class="page-link" aria-label="Next" @click="loadBroadcasts(broadcasts.links.next)" v-if="broadcasts.links.next">
                                <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.next') }}</span>
                            </button>
                            <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('pagination.next') }}</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

            <table class="table table-data">
                <colgroup>
<!--                    <col width="48px" v-if="caller==='channel'">-->
                    <col style="min-width: 164px; width: 20%;">
                    <col width="164px">
                    <col width="164px">
                    <col>
                    <col>
                    <col>
                    <col>
                    <col>
                    <col>
                    <col>
                    <col v-if="usekollusChatting">
                    <col v-if="usekollusChatting">
                    <col v-if="usekollusChatting">
                </colgroup>
                <thead>
                    <tr>
                        <!-- 통계 유지를 위해서 방송 삭제하는 버튼 제거 -->
                        <!--                        <th v-if="caller==='channel'" class="select-item">-->
<!--                            <div class="form-checkbox" v-if="haveManagerRight">-->
<!--                                <input type="checkbox" id="select_all" :value="true" v-model="selectAll">-->
<!--                                <label for="select_all"></label>-->
<!--                            </div>-->
<!--                        </th>-->
                        <th>
                            {{ $t('words.title') }}
                            <i :class="{'fa':true, 'fa-sort':true, 'fa-sort-up':order === 'title_asc'}" v-if="order === 'title_asc'" @click="changeOrder('title_desc')"></i>
                            <i :class="{'fa':true, 'fa-sort':true, 'fa-sort-down':order === 'title_desc'}" v-else-if="order === 'title_desc'" @click="changeOrder('title_asc')"></i>
                            <i :class="{'fa':true, 'fa-sort':true}" v-else @click="changeOrder('title_desc')"></i>
                        </th>
                        <th>{{ $t('words.key') }}</th>
                        <th v-tooltip="{ content: $t('words.started_at'), html:false }">{{ $t('words.started_at') }}</th>
                        <th v-tooltip="{ content: $t('words.ended_at'), html:false }">{{ $t('words.ended_at') }}</th>
                        <th class="cell--number" v-tooltip="{ content: $t('words.broadcast_interval'), html:false }">{{ $t('words.broadcast_interval') }}</th>
                        <th class="cell--number" v-tooltip="{ content: $t('words.watch_time'), html:false }">{{ $t('words.watch_time') }}</th>
                        <th class="cell--number" v-tooltip="{ content: $t('words.accumulate_viewers'), html:false }">{{ $t('words.accumulate_viewers') }}</th>
                        <th class="cell--number" v-tooltip="{ content: $t('words.visitor_counts'), html:false }">{{ $t('words.visitor_counts') }}</th>
                        <th v-tooltip="{ content: $t('words.auto_recording'), html:false }">{{ $t('words.auto_recording') }}</th>
                        <th v-tooltip="{ content: $t('words.manual_recording'), html:false }">{{ $t('words.manual_recording') }}</th>
                        <th v-if="usekollusChatting" v-tooltip="{ content: $t('words.chatting_unique_user_count'), html:false }">{{ $t('words.chatting_unique_user_count') }}</th>
                        <th v-if="usekollusChatting" v-tooltip="{ content: $t('words.chatting_sum_message_count'), html:false }">{{ $t('words.chatting_sum_message_count') }}</th>
                        <th v-if="usekollusChatting" v-tooltip="{ content: $t('words.chatting_download'), html:false }">{{ $t('words.chatting_download') }}</th>
                    </tr>
                    </thead>
                <tbody v-if="broadcasts.load & (broadcasts.meta.total !== 0)">
                <tr v-for="broadcast in broadcasts.data" :key="broadcast.id">
                    <!-- 통계 유지를 위해서 방송 삭제하는 버튼 제거 -->
<!--                    <td v-if="caller==='channel'">-->
<!--                        <div class="form-checkbox" v-if="haveManagerRight && (!broadcast.is_onair && (broadcast.ended_at !== ''))">-->
<!--                            <input type="checkbox" :id="`broadcast_${broadcast.id}`" :value="true" v-model="broadcast.selected" >-->
<!--                            <label :for="`broadcast_${broadcast.id}`"></label>-->
<!--                        </div>-->
<!--                    </td>-->
                    <td>
                        <span class="badge badge__live" style="margin: 0" v-if="broadcast.is_onair && (broadcast.ended_at === '')">{{ $t('words.live_onair') }}</span>
                        <span v-if="broadcast.is_onair" class="list__channel__name" v-tooltip="{ content: broadcast.title, html:false }">{{ broadcast.title }}</span>
                        <span v-else>
                            <span v-if="haveManagerRight">
                                <router-link :to="{ name: 'cms-channels-broadcast', params: { channel_id: channel.id, broadcast_id: broadcast.id } }" class="text-link">{{ broadcast.title }}</router-link>
                            </span>
                            <span v-else>
                                <span class="list__channel__name" v-tooltip="{ content: broadcast.title, html:false }">{{ broadcast.title }}</span>
                            </span>
                        </span>
                    </td>
                    <td>{{ broadcast.key }}</td>
                    <td><span v-tooltip="{ content: renderDatetime(broadcast.started_at), html:false }">{{ renderDatetime(broadcast.started_at) }}</span></td>
                    <td><span v-tooltip="{ content: renderDatetime(broadcast.paused_at), html:false }">{{ renderDatetime(broadcast.paused_at) }}</span></td>
                    <td class="cell--number"><span v-tooltip="{ content: broadcast.interval, html:false }">{{ broadcast.interval}}</span></td>
                    <td class="cell--number"><span v-if="showStats(broadcast)" v-tooltip="{ content: renderStatData(broadcast.watch_time), html:false }">{{ renderStatData(broadcast.watch_time) }}</span></td>
                    <td class="cell--number"><span v-if="showStats(broadcast)">{{ renderStatData(broadcast.sum_user) }}</span></td>
                    <td class="cell--number"><span v-if="showStats(broadcast)">{{ renderStatData(broadcast.request_count) }}</span></td>
                    <td>
                        <button v-if="!broadcast.is_onair && (broadcast.liveMediaRecordingFiles.segment.length > 0)" @click.prevent="playBroadcast(broadcast,'segment')" class="btn__rec-playlist"><i class="icon icon-play"></i>{{broadcast.liveMediaRecordingFiles.segment.length}}
                        </button>
                        <span v-else>-</span>
                    </td>
                    <td>
                        <button v-if="!broadcast.is_onair && (broadcast.liveMediaRecordingFiles.duplicate.length > 0)" @click.prevent="playBroadcast(broadcast,'duplicate')" class="btn__rec-playlist"><i class="icon icon-play"></i>{{broadcast.liveMediaRecordingFiles.duplicate.length}}</button>
                        <span v-else>-</span>
                    </td>
                    <td class="cell--number" v-if="usekollusChatting"><span v-if="showChatStats(broadcast)">{{ renderStatData(broadcast.unique_user_count)}}</span></td>
                    <td class="cell--number" v-if="usekollusChatting"><span v-if="showChatStats(broadcast)">{{ renderStatData(broadcast.sum_message_count)}}</span></td>
                    <td class="text-center" v-if="usekollusChatting">
                        <span v-if="!broadcast.is_onair">
                            <v-popover
                                offset="16"
                                placement="left"
                                @hide="broadcast.popover_open=false"
                                :open="broadcast.popover_open"
                            >
<!--                                @show="broadcast.popover_open=true"-->
                                <button class="tooltip-target btn btn--icon--sm" @click="broadcast.popover_open=true"><i class="icon icon-download" ></i></button>
                                <template slot="popover">
                                    <chatting-download-fields :channel="channel" :broadcast="broadcast" :open="broadcast.popover_open"></chatting-download-fields>
<!--                                    <a v-close-popover class="popover-close"><i class="icon icon-close"></i></a>-->
                                </template>
                            </v-popover>
                        </span>
                    </td>
                    <!--<td class="td__minimize">-->
                        <!--<div v-if="!broadcast.is_onair && (broadcast.ended_at !== '')">-->
                            <!--<div v-if="broadcast.liveMediaRecordingFiles.length === 1">-->
                                <!--<a class="btn btn-icon" :href="doDownload(broadcast.liveMediaRecordingFiles[0])">-->
                                    <!--<i class="icon icon-download"></i>-->
                                <!--</a>-->
                            <!--</div>-->
                            <!--<div class="dropdown" v-else-if="broadcast.liveMediaRecordingFiles.length > 1">-->
                                <!--<button class="btn btn-icon dropdown-toggle" type="button" id="downloadMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
                                    <!--<i class="icon icon-download"></i>-->
                                <!--</button>-->
                                <!--<div class="dropdown-menu" aria-labelledby="downloadMenuButton">-->
                                    <!--<a class="dropdown-item" :href="doDownload(recordingFile)" v-for="(recordingFile, index) in broadcast.liveMediaRecordingFiles" :key="recordingFile.id">download {{index+1}}</a>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--&lt;!&ndash;<button class="btn btn-flat" v-if="!broadcast.is_onair">&ndash;&gt;-->
                        <!--&lt;!&ndash;<i class="icon icon-download"></i>&ndash;&gt;-->
                        <!--&lt;!&ndash;</button>&ndash;&gt;-->
                    <!--</td>-->
                </tr>
                </tbody>
                <tbody v-else-if="broadcasts.load">
                <tr>
                    <td :colspan="usekollusChatting?13:10" class="td__message">
                        <!-- 통계 유지를 위해서 방송 삭제하는 버튼 제거 -->
<!--                    <td :colspan="caller==='creator'?9:10" class="td__message">-->
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td :colspan="usekollusChatting?13:10" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                    <!-- 통계 유지를 위해서 방송 삭제하는 버튼 제거 -->
<!--                    <td :colspan="caller==='creator'?9:10" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>-->
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import DateTimeMixin from '../../mixin/DateTimeMixin';
import ChattingDownloadFields from './ChattingDownloadFields';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        ChattingDownloadFields,
        VueDatePicker,
    },
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        caller: {
            type: [String],
            require: true,
        },
        chatting_available: {
            type: Boolean,
            required: true,
        },
        chatting_type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            order: 'id_desc',
            selectedBroadcast: null,
            selectAll: false,
            startDayLimit: '',
            endDayLimit: '',
            startDay: '',
            endDay: '',
            rangeDay: [],
            startDate: '',
            endDate: '',
            period: '',
            broadcasts: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 0,
                },
                load: false,
            },
        };
    },
    mounted() {
    },
    methods: {
        load() {
            this.loadBroadcasts(this.broadcastsApiUri);
        },
        reload() {
            this.loadBroadcasts(`${this.broadcastsApiUri}&page=${this.broadcasts.meta.current_page}`);
        },
        initialize() {
            this.initSelectableDate('30d');
            this.changePeriod('1d');
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';
            this.loadBroadcasts(this.broadcastsApiUri);
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.loadBroadcasts(this.broadcastsApiUri);
        },
        loadBroadcasts(broadcastApi) {
            if (this.$moment(this.startDay) < this.$moment(this.startDayLimit)) {
                this.$toasted.error(this.$t('paragraphs.channel.select_start_date_bigger', { date: this.startDayLimit }));
                return;
            }

            if (this.$moment(this.endDay) > this.$moment(this.endDayLimit)) {
                this.$toasted.error(this.$t('paragraphs.channel.select_end_date_smaller', { date: this.endDayLimit }));
                return;
            }
            this.broadcasts.load = false;
            axios.get(broadcastApi).then((response) => {
                this.broadcasts = response.data;
                this.selectAll = false;
                this.broadcasts.data = this.broadcasts.data
                    .map(broadcast => ({
                        ...broadcast,
                        selected: this.selectAll,
                        repeat: null,
                        getStats: false,
                        watch_time: null,
                        sum_user: null,
                        request_count: null,
                        // kollus chatting report api는 기존 report api와 달라서.. 별도로 만듬.
                        getChatStats: false,
                        sum_message_count: null,
                        unique_user_count: null,
                        popover_open: false,
                    }));

                _.forEach(this.broadcasts.data, (broadcast) => {
                    if (broadcast.is_onair) {
                        this.calBroadcastDuration(broadcast);
                    }
                });
                this.broadcasts.load = true;
                this.getSummaryChannelData();
            });
        },
        doDownload(recordingFile) {
            return `/cms/${this.selectedServiceAccount.key}/recording-files/${recordingFile.id}/download`;
        },
        changeOrder(order) {
            this.order = order;
            this.loadBroadcasts(this.broadcastsApiUri);
        },
        // <!-- 통계 유지를 위해서 방송 삭제하는 버튼 제거 -->
        // doDestroyBroadcasts() {
        //     if (!this.haveManagerRight) {
        //         return;
        //     }
        //     if (confirm(this.$t('paragraphs.message.confirm.remove_broadcast'))) {
        //         const selectedBroadcastIds = this.broadcasts.data.filter(broadcast => broadcast.selected)
        //             .map(broadcast => broadcast.id);
        //
        //         if (selectedBroadcastIds.length === 0) {
        //             this.$toasted.error(this.$t('paragraphs.please_select_item'));
        //             return;
        //         }
        //
        //         axios.delete(`/cms/${this.selectedServiceAccount.key}/broadcasts`, { data: { selected_ids: selectedBroadcastIds } }).then(() => {
        //             this.$toasted.success(this.$t('paragraphs.message.success.remove_broadcast'));
        //             this.loadBroadcasts(this.broadcastsApiUri);
        //         }).catch((error) => {
        //             this.$toasted.error(this.$t('paragraphs.message.error.remove_broadcast'));
        //             console.log(error.response.data.errors);
        //         });
        //     }
        // },
        getDuration(started) {
            const startedUtc = this.$moment.utc(started);
            const nowDate = this.$moment().utc();
            let diff = nowDate.format('X') - startedUtc.format('X');
            // const days = Math.floor(diff / (24 * 60 * 60));
            // if (days > 0) {
            //     diff %= (24 * 60 * 60);
            // }
            const hours = Math.floor(diff / (60 * 60));
            const hoursStr = (hours < 10) ? `0${hours}` : hours;
            if (hours > 0) {
                diff %= (60 * 60);
            }
            const minutes = Math.floor(diff / 60);
            const minutesStr = (minutes < 10) ? `0${minutes}` : minutes;
            if (minutes > 0) {
                diff %= (60);
            }
            const seconds = diff;
            const secondsStr = (seconds < 10) ? `0${seconds}` : seconds;
            // if (days > 0) {
            //     return `${days}d ${hoursStr}:${minutesStr}:${secondsStr}`;
            // }

            return `${hoursStr}:${minutesStr}:${secondsStr}`;
        },
        calBroadcastDuration(broadcast) {
            const broadcastIns = broadcast;
            broadcastIns.repeat = setInterval(() => {
                broadcastIns.interval = this.getDuration(broadcast.started_at);

                if (!broadcastIns.is_onair) {
                    clearInterval(broadcastIns.repeat);
                }
            }, 1000);
        },
        showStats(broadcast) {
            // 통계 데이터를 가져오지 못할 때 - 로 표시하도록 수정.
            // return !broadcast.is_onair && broadcast.getStats && (broadcast.ended_at !== '');
            return !broadcast.is_onair && (broadcast.ended_at !== '');
        },
        showChatStats(broadcast) {
            // 통계 데이터를 가져오지 못할 때 - 로 표시하도록 수정.
            // return !broadcast.is_onair && broadcast.getChatStats && (broadcast.ended_at !== '');
            return !broadcast.is_onair && (broadcast.ended_at !== '');
        },
        getSummaryChannelData() {
            const broadcasts = this.broadcasts.data.map(broadcast => broadcast.key);

            this.getSummaryBroadcastData(broadcasts);
            this.getSummaryBroadcastChatData(broadcasts);
        },
        getSummaryBroadcastChatData(broadcasts) {
            let apiUrl = '';
            if (this.caller === 'channel') {
                apiUrl = `/cms/${this.selectedServiceAccount.key}/statistics/broadcasts_chat/${this.channel.id}`;
            } else {
                apiUrl = '/cms/creator/statistics/broadcasts_chat';
            }
            axios.post(apiUrl, {
                broadcasts,
            }).then((response) => {
                _.forEach(response.data.results, (item) => {
                    _.forEach(this.broadcasts.data, (broadcast) => {
                        const lBroadcast = Object.create(broadcast);
                        if (lBroadcast.key === item.broadcast_key) {
                            lBroadcast.unique_user_count = item.unique_user_count;
                            lBroadcast.sum_message_count = item.sum_message_count;

                            // 통계 데이터를 가져오지 못할 때 - 로 표시하도록 수정.
                            // lBroadcast.getChatStats = true;
                            return false;
                        }
                        return true;
                    });
                });
            }).catch((error) => {
                // 채팅 통계는 prod 배포가 되지 않아서 toast 삭제함.
//                this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        getSummaryBroadcastData(broadcasts) {
            let apiUrl = '';
            if (this.caller === 'channel') {
                apiUrl = `/cms/${this.selectedServiceAccount.key}/statistics/summary_channel/${this.channel.id}`;
            } else {
                apiUrl = '/cms/creator/statistics/summary_channel';
            }
            axios.post(apiUrl, {
                broadcasts,
            }).then((response) => {
                _.forEach(response.data.results, (item) => {
                    _.forEach(this.broadcasts.data, (broadcast) => {
                        const lBroadcast = Object.create(broadcast);
                        if (lBroadcast.key === item.broadcast_key) {
                            lBroadcast.sum_user = item.sum_user;
                            lBroadcast.request_count = item.request_count;
                            lBroadcast.watch_time = item.watch_time;
                            // 통계 데이터를 가져오지 못할 때 - 로 표시하도록 수정.
                            // lBroadcast.getStats = true;
                            return false;
                        }
                        return true;
                    });
                });
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        playBroadcast(broadcast,recordingKind) {
            this.$emit('playBroadcast', {
                broadcast,
                recordingKind,
            });
        },
        recordingFilesCount(broadcast) {
            return broadcast.liveMediaRecordingFiles.segment.length + broadcast.liveMediaRecordingFiles.duplicate.length;
        },
        getChattingDownloadUrl(broadcast) {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}/broadcasts/${broadcast.id}/chatting-download`;
        },
        renderStatData(result, emptyDefault = '-') {
            return _.isNil(result) ? emptyDefault : result;
        },
    },
    computed: {
        channelApi() {
            if (this.caller === 'channel') {
                return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}`;
            }
            return '/cms/creator/channel';
        },
        broadcastsApiUri() {
            if (this.caller === 'channel') {
                return `${this.channelApi}/broadcasts?order=${this.order}&started_at=${this.startDate}&ended_at=${this.endDate}`;
            }
            return `/cms/creator/broadcasts?order=${this.order}&started_at=${this.startDate}&ended_at=${this.endDate}`;
        },
        usekollusChatting() {
            return (this.chatting_available && this.channel.use_chatting_service && (
                this.chatting_type === 'kollus' || this.chatting_type === 'kollus_server_only'
            ));
        },
        loadChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
    },
    watch: {
        loadChannel(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
        selectAll(newValue) {
            console.log(newValue);
            this.broadcasts.data = this.broadcasts.data
                .map(broadcast => ({ ...broadcast, selected: newValue }));
        },
    },
};
</script>
